<template>
  <div class="product-detail">
    <div class="header">
      <el-container>
        <el-header>
          <Head />
        </el-header>
      </el-container>
    </div>

    <!-- 二级导航栏 -->
    <div class="sub-nav">
      <div class="nav-container">
        <div class="nav-left">
          <div
            class="nav-item dropdown"
            v-for="(menu, index) in productMenus"
            :key="index"
            @mouseenter="handleMenuEnter(index)"
            @mouseleave="handleMenuLeave"
          >
            <span class="nav-title">{{ menu.title }}</span>
            <div class="dropdown-content" v-show="currentIndex === index">
              <div class="product-grid">
                <router-link
                  v-for="product in menu.children"
                  :key="product.id"
                  :to="product.path"
                  class="product-item"
                >
                  <img :src="product.icon" :alt="product.name" />
                  <div class="product-info">
                    <h4>{{ product.name }}</h4>
                    <p>{{ product.description }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="nav-right">
          <router-link
            v-for="link in navLinks.filter((l) => !l.path.startsWith('http'))"
            :key="link.path"
            :to="link.path"
            class="nav-link"
          >
            {{ link.name }}
          </router-link>
          <a
            v-for="link in navLinks.filter((l) => l.path.startsWith('http'))"
            :key="link.path"
            :href="link.path"
            target="_blank"
            class="nav-link"
          >
            {{ link.name }}
          </a>
        </div>
      </div>
    </div>

    <div class="product-content">
      <div class="product-banner">
        <div class="banner-content">
          <div class="image-gallery">
            <div class="main-image">
              <img
                :src="productImagess[selectedImageIndex]"
                alt="Selected product image"
              />
            </div>
            <div class="thumbnails">
              <img
                v-for="(image, index) in productImages"
                :key="index"
                :src="image"
                :class="{ active: selectedImageIndex === index }"
                @click="selectImage(index)"
                :alt="'Product image ' + (index + 1)"
              />
            </div>
          </div>
          <div class="product-info">
            <h4 class="model">YBM800KS</h4>
            <h2 class="title">全球通工业级4G DTU产品</h2>
            <p class="description">
              采用稳定可靠的通信模组，实现串口与4G
              Cat,1互传，支持全球运营商网络。产品提供1个RS485标准接口，支持宽压供电，加强防雷设计，安全稳定可靠。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="specs-container">
        <h2 class="specs-title">产品规格</h2>
        <table class="specs-table">
          <tr class="header-row">
            <th>分类</th>
            <th>参数</th>
            <th>描述</th>
          </tr>
          <tr>
            <td>系统</td>
            <td>模组</td>
            <td>EG800K-CN</td>
          </tr>
          <tr>
            <td rowspan="3">电源</td>
            <td>输入电压</td>
            <td>DC 5~60V</td>
          </tr>
          <tr>
            <td>功耗</td>
            <td>0.9W（清醒）</td>
          </tr>
          <tr>
            <td>反接保护</td>
            <td>支持</td>
          </tr>
          <tr>
            <td rowspan="7">485串口</td>
            <td>串口数量</td>
            <td>1 × RS485（RS232可选），1 x Uart</td>
          </tr>
          <tr>
            <td>串口波特率</td>
            <td>2400bps~115200bps</td>
          </tr>
          <tr>
            <td>数据位</td>
            <td>7,8</td>
          </tr>
          <tr>
            <td>校验位</td>
            <td>None, Even, Odd</td>
          </tr>
          <tr>
            <td>停止位</td>
            <td>1, 2</td>
          </tr>
          <tr>
            <td>串口保护</td>
            <td>ESD ±8KV（接触），±15KV（空气）； EFT 2KV, 40A （5/50ns）</td>
          </tr>
          <tr>
            <td>数量</td>
            <td>1</td>
          </tr>
          <tr>
            <td rowspan="2">SIM卡</td>
            <td>规格</td>
            <td>插拔式（贴片式可选）</td>
          </tr>
          <tr>
            <td>保护</td>
            <td>内置15KV ESD保护</td>
          </tr>
          <tr>
            <td rowspan="4">4G功能</td>
            <td rowspan="4">模组EG800K-CN</td>
            <td>存储配置8MB+4MB</td>
          </tr>
          <tr>
            <td>支持国内运营商4G频段（全网通）</td>
          </tr>
          <tr>
            <td>LTE FDD:Band 1,3,5,8</td>
          </tr>
          <tr>
            <td>LTE TDD:Band 34,38,39,40,41</td>
          </tr>
          <tr>
            <td>定位功能</td>
            <td>GNSS</td>
            <td>北斗/GPS/QZSS</td>
          </tr>
          <tr>
            <td rowspan="2">天线</td>
            <td>天线接口数量</td>
            <td>2</td>
          </tr>
          <tr>
            <td>天线接口类型</td>
            <td>SMA孔式</td>
          </tr>
          <tr>
            <td rowspan="2">告警功能</td>
            <td>一键呼叫</td>
            <td>支持</td>
          </tr>
          <tr>
            <td>一键告警</td>
            <td>支持</td>
          </tr>
          <tr>
            <td rowspan="2">指示灯</td>
            <td>电源状态灯</td>
            <td>上电时常亮，系统不运行时熄灭。</td>
          </tr>
          <tr>
            <td>运行状态灯</td>
            <td>4G通信1S闪烁</td>
          </tr>
          <tr>
            <td rowspan="6">安规认证</td>
            <td>MTBF</td>
            <td>>3万小时</td>
          </tr>
          <tr>
            <td rowspan="5">EMC</td>
            <td>EN 55022: 2006/A1: 2007 (CE &RE) Class B</td>
          </tr>
          <tr>
            <td>IEC 61000-4-2 (ESD) Level 3</td>
          </tr>
          <tr>
            <td>IEC 61000-4-3 (RS) Level 4</td>
          </tr>
          <tr>
            <td>IEC 61000-4-4 (EFT) Level 4</td>
          </tr>
          <tr>
            <td>IEC 61000-4-5 (Surge)Level 3</td>
          </tr>
          <tr>
            <td rowspan="2">环境</td>
            <td>工作温度、湿度</td>
            <td>-40~85℃，5~95% RH</td>
          </tr>
          <tr>
            <td>存储温度、湿度</td>
            <td>-40~85℃，5~95% RH</td>
          </tr>
          <tr>
            <td>其他</td>
            <td>外壳</td>
            <td>铝金外壳</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="footer">
      <v-footer></v-footer>
    </div>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import vFooter from "@/components/footer2.vue";

export default {
  name: "ProductDetail",
  components: {
    Head,
    vFooter,
  },
  data() {
    return {
      selectedImageIndex: 0,
      productImages: [
        require("../../../../public/img/internet/Frame600.png"),
        require("../../../../public/img/internet/Frame601.png"),
        require("../../../../public/img/internet/Frame602.png"),
        require("../../../../public/img/internet/Frame603.png"),
      ],
      productImagess: [
        require("../../../../public/img/internet/主图2-1.png"),
        require("../../../../public/img/internet/主图2-2.png"),
        require("../../../../public/img/internet/主图2-3.png"),
        require("../../../../public/img/internet/主图2-4.png"),
      ],
      currentIndex: null,
      productMenus: [
        {
          title: "智联产品",
          children: [
            {
              id: 1,
              name: "YBM307GA",
              path: "/product/YBM307DA",
              icon: require("../../../../public/img/internet/image151.png"),
            },
            {
              id: 2,
              name: "YBM708ELGA",
              path: "/product/YBM708EUGA",
              icon: require("../../../../public/img/internet/image161.png"),
            },
            {
              id: 3,
              name: "YBM307UWG",
              path: "/product/YBM507JWG",
              icon: require("../../../../public/img/internet/image171.png"),
            },
            {
              id: 4,
              name: "YB2000B",
              path: "/product/YB200XB",
              icon: require("../../../../public/img/internet/image181.png"),
            },
            {
              id: 5,
              name: "YG312",
              path: "/product/YG512",
              icon: require("../../../../public/img/internet/image191.png"),
            },
            {
              id: 6,
              name: "YBM800KS",
              path: "/product/YBM800KS",
              icon: require("../../../../public/img/internet/image201.png"),
            },
          ],
        },
        {
          title: "DTU",
          children: [
            {
              id: 1,
              name: "YBM307GA",
              path: "/product/YBM307DA",
              icon: require("../../../../public/img/internet/image151.png"),
            },
            {
              id: 2,
              name: "YBM708ELGA",
              path: "/product/YBM708EUGA",
              icon: require("../../../../public/img/internet/image161.png"),
            },
            {
              id: 5,
              name: "YG312",
              path: "/product/YG512",
              icon: require("../../../../public/img/internet/image191.png"),
            },
            {
              id: 6,
              name: "YBM800KS",
              path: "/product/YBM800KS",
              icon: require("../../../../public/img/internet/image201.png"),
            },
          ],
        },
        {
          title: "智能网关",
          children: [
            {
              id: 3,
              name: "YBM307UWG",
              path: "/product/YBM507JWG",
              icon: require("../../../../public/img/internet/image171.png"),
            },
            {
              id: 4,
              name: "YB2000B",
              path: "/product/YB200XB",
              icon: require("../../../../public/img/internet/image181.png"),
            },
          ],
        },
      ],
      navLinks: [
        { name: "产品详情", path: "/productDetail" },
        { name: "产品参数", path: "/params" },
        { name: "资料下载", path: "/download" },
        { name: "在线购买", path: "https://m.tb.cn/h.hZXfHaXscQFn4yi" },
      ],
    };
  },
  computed: {
    selectedImage() {
      return this.productImages[this.selectedImageIndex];
    },
  },
  methods: {
    selectImage(index) {
      this.selectedImageIndex = index;
    },
    handleMenuEnter(index) {
      this.currentIndex = index;
    },
    handleMenuLeave() {
      this.currentIndex = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link:nth-child(4) {
  color: white;
  background: blue;
}
.product-detail {
  width: 100%;
  min-height: 100vh;
  //   background-color: #0a0c0f;
  color: black;
  //   padding-top: 128px;

  .sub-nav {
    width: 100%;
    height: 64px;
    background: #e9eeff;
    color: black;
    backdrop-filter: blur(10px);
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 100;
    transition: all 0.3s ease;

    .nav-container {
      max-width: 1400px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      color: black;
    }

    .nav-left {
      display: flex;
      gap: 32px;
    }

    .nav-right {
      display: flex;
      gap: 10px;
    }

    .nav-item {
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;

      .nav-title {
        color: black;
        font-size: 16px;
        transition: color 0.3s;

        &:hover {
          color: #409eff;
        }
      }
    }

    .dropdown-content {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      top: 45px; // 头部+二级导航高度
      width: 1350px;
      min-width: unset;
      max-width: 100vw;
      background: #cedfff;
      border-radius: 4px;
      padding: 6px 24px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      border: 1px solid rgba(255, 255, 255, 0.3);
      opacity: 0.98;
      overflow: visible;
      z-index: 100;
    }

    .product-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 20px;
      position: relative;
      width: 100px;
      z-index: 1;
    }

    .product-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // 移除会撑满格子的宽度设置，不要设置 width: 100% 或 flex: 1
      min-width: 100px; // 可选，最小宽度
      max-width: 180px; // 可选，最大宽度
      padding: 16px 1px; // 横向内边距可适当缩小
      border-radius: 4px;
      text-decoration: none;
      transition: all 0.3s;

      &:hover {
        background: rgba(64, 158, 255, 0.1);
      }

      img {
        width: 61px;
        height: 36px;
        margin-right: 16px;
        // border-radius: 4px;
        margin: 0 0 8px 0;
      }

      .product-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        h4 {
          color: #666;
          font-size: 16px;
          margin: 0 0 4px 0;
        }

        p {
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          margin: 0;
        }
      }
    }

    .nav-link {
      // color: black;
      text-decoration: none;
      font-size: 16px;
      padding: 8px 16px;
      border-radius: 4px;
      transition: all 0.3s;

      &:hover {
        color: white;
        background: blue;
      }

      &.router-link-active {
        color: #409eff;
        background: rgba(64, 158, 255, 0.1);
      }
    }
  }

  .product-content {
    // background: url("../../../../public/img/internet/主图banner1-1.png")
      // no-repeat;
    background-size: 100% 530px;
    width: 100%;
    // padding-top: 64px;
    position: relative;
  }

  .product-banner {
    // background: url("../../../../public/img/internet/产品详情背景.jpg");
    width: 100%;
    max-height: 600px;
    background: #e9eeff;
    padding: 60px 0;
  }

  .banner-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 20px;
    gap: 40px;
  }

  .image-gallery {
    flex: 1;
    max-width: 500px;
    margin-top: 100px;
    margin-left: -100px;

    .main-image {
      width: 100%;
      margin-bottom: 20px;
      border-radius: 8px;
      overflow: hidden;
      margin-left: 200px;

      img {
        width: 292px;
        height: 230px;
        height: auto;
        object-fit: cover;
      }
    }

    .thumbnails {
      display: flex;
      gap: 10px;

      img {
        width: 136px;
        height: 102px;
        object-fit: cover;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 2px solid transparent;
        margin-left: 10px;
        &:hover {
          transform: translateY(-2px);
        }

        &.active {
          border-color: #409eff;
        }
      }
    }
  }

  .product-info {
    flex: 1;
    // min-width: 618px;

    .model {
      font-size: 38px;
      color: black;
      margin-bottom: 20px;
      font-weight: normal;
    }

    .title {
      // font-size: 48px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 30px;
    }

    .features {
      display: flex;
      gap: 12px;
      margin-bottom: 30px;

      .feature-tag {
        padding: 8px 16px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        // font-size: 14px;
      }
    }

    .description {
      font-size: 16px;
      line-height: 1.6;
      color: #666666;
      max-width: 618px;
      font-weight: 400;
    }
  }

  .product-image {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      height: auto;
    }
  }
}
.model {
  position: absolute;
  top: 230px;
  right: 675px;
}
.title {
  position: absolute;
  top: 290px;
  right: 645px;
  font-size: 20px;
  font-weight: 200;
}
.features {
  position: absolute;
  top: 280px;
  right: 230px;

  .feature-tag:nth-child(1) {
    font-size: 20px;
    width: 152px;
    height: 44px;
    background: #454545;
    line-height: 44px;
  }
  .feature-tag:nth-child(2) {
    width: 152px;
    height: 44px;
    margin-left: 20px;
    background: #454545;
    line-height: 44px;
    font-size: 20px;
  }
  .feature-tag:nth-child(3) {
    width: 152px;
    height: 44px;
    margin-left: 20px;
    background: #454545;
    line-height: 44px;
    font-size: 20px;
  }
}
.description {
  text-align: left;
  position: absolute;
  top: 360px;
  right: 260px;
  color: #666666;
}
.imgs {
  margin-top: -254px;
  margin-bottom: 100px;
  .img1 {
    img {
      width: 1400px;
      height: 760px;
    }
  }
  .img2 {
    img {
      width: 1400px;
      height: 560px;
    }
  }
  .img3 {
    img {
      width: 1400px;
      height: 2310px;
    }
  }
}

.specs-container {
  max-width: 1400px;
  margin: 60px auto;
  padding: 0 20px;
}

.specs-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: center;
}

.specs-table {
  width: 100%;
  border-collapse: collapse;
  // background: #cfcbcb;
  th,
  td {
    padding: 12px 20px;
    text-align: left;
    border: 1px solid #e0e0e0;
  }

  th {
    background: #f0f0f0;
    font-weight: normal;
  }

  tr:nth-child(even) {
    background: #fafafa;
  }

  .header-row {
    th {
      &:first-child {
        width: 15%;
      }
      &:nth-child(2) {
        width: 25%;
      }
      &:last-child {
        width: 60%;
      }
    }
  }
}
</style>
